export const CategoriesData = [
  {
    id: 1,
    heading: 'Top Stories',
  },
  {
    id: 2,
    heading: 'India',
  },
  {
    id: 3,
    heading: 'World',
  },
  {
    id: 4,
    heading: 'Business',
    options: [
      {
        id: 0,
        heading: 'All',
      },
      {
        id: 1,
        heading: 'Money',
        options: [
          {
            id: 0,
            heading: 'All',
          },
          {
            id: 1,
            heading: 'Markets',
          },
          {
            id: 2,
            heading: 'Finance News',
          },
        ],
      },
      {
        id: 2,
        heading: 'Auto',
        options: [
          {
            id: 0,
            heading: 'All',
          },
          {
            id: 1,
            heading: 'Cars',
          },
          {
            id: 2,
            heading: 'Two Wheelers',
          },
        ],
      },
    ],
  },
  {
    id: 5,
    heading: 'Technology',
    options: [
      {
        id: 0,
        heading: 'All',
      },
      {
        id: 1,
        heading: 'Gadgets',
      },
      {
        id: 2,
        heading: 'Mobile Phones',
      },
      {
        id: 3,
        heading: 'Electronics',
      },
      {
        id: 4,
        heading: 'Apps',
      },
    ],
  },
  {
    id: 6,
    heading: 'Sports',
    options: [
      {
        id: 0,
        heading: 'All',
      },
      {
        id: 1,
        heading: 'Cricket',
        options: [
          {
            id: 0,
            heading: 'All',
          },
          {
            id: 1,
            heading: 'IPL',
          },
          {
            id: 2,
            heading: 'Indian ODI /T20 / ODI',
          },
          {
            id: 3,
            heading: 'Indian Ranji',
          },
          {
            id: 4,
            heading: 'Other Countries Cricket',
          },
        ],
      },
      {
        id: 2,
        heading: 'Football',
      },
      {
        id: 3,
        heading: 'Kabaddi',
      },
      {
        id: 4,
        heading: 'Tennis',
      },
    ],
  },
  {
    id: 7,
    heading: 'Lifestyle',
    options: [
      {
        id: 0,
        heading: 'All',
      },
      {
        id: 1,
        heading: 'Beauty',
      },
      {
        id: 2,
        heading: 'Style',
      },
      {
        id: 3,
        heading: 'Parenting',
      },
      {
        id: 4,
        heading: 'Home And Garden',
      },
      {
        id: 5,
        heading: 'Horoscope',
      },
      {
        id: 6,
        heading: 'Relationships',
      },
      {
        id: 7,
        heading: 'Recipes',
      },
      {
        id: 8,
        heading: 'Farming',
      },
    ],
  },
  {
    id: 8,
    heading: 'Careers',
  },
  {
    id: 9,
    heading: 'Health',
    options: [
      {
        id: 1,
        heading: 'All',
      },

      {
        id: 2,
        heading: 'Fitness',
      },
      {
        id: 3,
        heading: 'Diet',
      },
      {
        id: 4,
        heading: 'Family Health',
      },
      {
        id: 5,
        heading: 'Weight Loss',
      },
    ],
  },
  {
    id: 10,
    heading: 'Entertainment',
    options: [
      {
        id: 0,
        heading: 'All',
      },
      {
        id: 1,
        heading: 'Books',
      },

      {
        id: 2,
        heading: 'TV',
      },
      {
        id: 3,
        heading: 'OTT',
      },
      {
        id: 4,
        heading: 'Gaming',
      },
      {
        id: 5,
        heading: 'Satire',
      },
      {
        id: 5,
        heading: 'Memes',
      },
    ],
  },
  {
    id: 11,
    heading: 'Telugu Movies',
    options: [
      {
        id: 0,
        heading: 'All',
      },
      {
        id: 1,
        heading: 'Celebrity news',
      },

      {
        id: 2,
        heading: 'Music',
      },
      {
        id: 3,
        heading: 'Movies',
      },
      {
        id: 4,
        heading: 'Reviews',
      },
    ],
  },
  {
    id: 12,
    heading: 'BollyWood',
    options: [
      {
        id: 0,
        heading: 'All',
      },
      {
        id: 1,
        heading: 'Celebrity news',
      },

      {
        id: 2,
        heading: 'Music',
      },
      {
        id: 3,
        heading: 'Movies',
      },
      {
        id: 4,
        heading: 'Reviews',
      },
    ],
  },

  {
    id: 13,
    heading: 'Travel',
  },
  {
    id: 14,
    heading: 'Science',
  },
  {
    id: 15,
    heading: 'Politics',
  },
  {
    id: 16,
    heading: 'Others',
  },
]
